import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容频道",
    links: [
      { label: "汽车新闻", to: "/news" },
      { label: "车型评测", to: "/reviews" },
      { label: "行业动态", to: "/industry" },
      { label: "全站搜索", to: "/search" },
    ],
  },
  {
    title: "热门分类",
    links: [
      { label: "轿车资讯", to: "/news/轿车" },
      { label: "SUV 资讯", to: "/news/SUV" },
      { label: "新能源车", to: "/news/新能源车" },
      { label: "性能跑车", to: "/reviews/性能跑车" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200 mt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-car-fill text-primary-950 text-xl" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                汽车资讯网
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              聚合最新汽车新闻、车型评测与行业动态，涵盖轿车、SUV、新能源车等多个细分领域，助你全面了解汽车世界。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-200"
                  title="社交入口（演示）"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 汽车资讯网 · 本站内容为演示数据，仅用于产品展示。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>权威 · 专业 · 及时</span>
            <span>京ICP备00000000号（演示）</span>
          </p>
        </div>
      </div>
    </footer>
  );
}